import { ACTIVITY_KINDS, type ActivityKind } from "@atlas/shared";

/** Narrow a search param or API value to an activity kind (spec 26). */
export function isActivityKind(v: unknown): v is ActivityKind {
  return typeof v === "string" && (ACTIVITY_KINDS as readonly string[]).includes(v);
}
